import React, { useState, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import { heroSlides, brand } from "../mock";

export default function Hero() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIndex((i) => (i + 1) % heroSlides.length), 6000);
    return () => clearInterval(t);
  }, []);

  return (
    <section id="top" className="relative h-screen w-full overflow-hidden">
      {/* Slides */}
      {heroSlides.map((s, i) => (
        <div
          key={s.place}
          className="absolute inset-0 transition-opacity duration-[1600ms] ease-in-out"
          style={{ opacity: i === index ? 1 : 0 }}
        >
          <img
            src={s.image}
            alt={s.place}
            className={`h-full w-full object-cover ${i === index ? "kenburns" : ""}`}
          />
          <div
            className="absolute inset-0"
            style={{
              background:
                "linear-gradient(180deg, rgba(14,35,56,0.55) 0%, rgba(14,35,56,0.15) 35%, rgba(14,35,56,0.30) 70%, rgba(14,35,56,0.72) 100%)",
            }}
          />
        </div>
      ))}

      {/* Content */}
      <div className="relative h-full max-w-[1500px] mx-auto px-6 md:px-10 flex flex-col justify-center">
        <div className="max-w-3xl">
          <p
            className="font-sans-ui tracking-wide-2 text-[0.7rem] md:text-[0.78rem] uppercase mb-6 text-cream/85 animate-[fadeUp_1s_ease]"
            style={{ color: "rgba(246,243,238,0.85)" }}
          >
            {brand.pillars.join("  \u00b7  ")}
          </p>
          <h1
            className="font-serif-display text-cream text-[3.2rem] md:text-[5.6rem] leading-[1.02] font-300"
            style={{ color: "var(--cream)" }}
          >
            Designing spaces<br />that move people
          </h1>
          <p
            className="mt-8 max-w-xl text-cream/85 text-base md:text-lg leading-relaxed font-300"
            style={{ color: "rgba(246,243,238,0.85)" }}
          >
            From ideas to inspiring spaces — end to end. Interior design, fit-out
            and construction, delivered as one seamless partnership.
          </p>
          <button
            onClick={() =>
              document.getElementById("spaces")?.scrollIntoView({ behavior: "smooth" })
            }
            className="btn-line btn-cream mt-10"
            style={{ color: "var(--cream)" }}
          >
            Explore our work
          </button>
        </div>
      </div>

      {/* place caption + slide indicators */}
      <div className="absolute bottom-8 left-0 w-full">
        <div className="max-w-[1500px] mx-auto px-6 md:px-10 flex items-end justify-between">
          <span
            className="font-sans-ui tracking-wide-3 text-[0.65rem] uppercase text-cream/70"
            style={{ color: "rgba(246,243,238,0.7)" }}
          >
            {heroSlides[index].place}
          </span>
          <div className="flex items-center gap-3">
            {heroSlides.map((s, i) => (
              <button
                key={s.place}
                onClick={() => setIndex(i)}
                className="h-[2px] transition-all duration-500"
                style={{
                  width: i === index ? 40 : 18,
                  backgroundColor: i === index ? "var(--cream)" : "rgba(246,243,238,0.4)",
                }}
                aria-label={`Slide ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:block">
        <ChevronDown size={22} strokeWidth={1.4} className="animate-bounce" style={{ color: "var(--cream)" }} />
      </div>

      <style>{`@keyframes fadeUp{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}`}</style>
    </section>
  );
}
